export default __webpack_public_path__ + "static/media/cpu.a35adb66.svg";